import * as Sentry from '@sentry/react';

// @ts-ignore
const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
// @ts-ignore
const APP_VERSION = import.meta.env.VITE_APP_VERSION;

function getEnvironment() {
  // eslint-disable-next-line no-restricted-globals
  if (window.location.hostname.includes('portal.stag')) {
    return 'staging';
    // eslint-disable-next-line no-restricted-globals
  } else if (window.location.hostname.includes('ngrok.io') || window.location.hostname.includes('localhost')) {
    return 'development';
  } else {
    return 'production';
  }
}

if (!SENTRY_DSN) {
  console.warn('Sentry DSN not provided, skipping Sentry initialization');
} else {
  console.info(`Initializing Sentry for environment: ${getEnvironment()}`);

  Sentry.init({
    dsn: SENTRY_DSN,
    release: APP_VERSION,
    environment: getEnvironment(),
    sendDefaultPii: true,
    integrations: [
      // See https://docs.sentry.io/platforms/javascript/configuration/integrations/captureconsole/
      Sentry.captureConsoleIntegration({
        levels: ['error'],
      }),
    ],
  });
}
